import React from 'react'
import PropTypes from 'prop-types'

const Circles = props => (
  <svg
    width={props.size}
    height={props.size}
    viewBox='0 0 96 96'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='52.421' cy='42.3158' r='40.5526' stroke='#BD9973'></circle>
    <circle
      opacity='0.4'
      cx='58.1052'
      cy='48'
      r='34.8684'
      stroke='#838489'
    ></circle>
    <circle opacity='0.2' cx='48' cy='48' r='47.5' stroke='#B3B4B8'></circle>
  </svg>
)

Circles.propTypes = {
  size: PropTypes.number,
}

Circles.defaultProps = {
  size: 96,
}

export default Circles
